import { render } from "./SectionMenu.vue?vue&type=template&id=54b83bce&scoped=true&ts=true"
import script from "./SectionMenu.vue?vue&type=script&lang=ts"
export * from "./SectionMenu.vue?vue&type=script&lang=ts"

import "./SectionMenu.vue?vue&type=style&index=0&id=54b83bce&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b83bce"]])

export default __exports__